import Vue from 'vue';

export const uppercase = (value) => {
  return value || value === 0 ? value.toString().toUpperCase() : '';
};

export const lowercase = (value) => {
  return value || value === 0 ? value.toString().toLowerCase() : '';
};

export const capitalize = (value) => {
  if (!value && value !== 0) return '';
  value = value.toString();

  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const truncate = (value, length) => {
  length = length || 15;
  if (!value || typeof value !== 'string') return '';
  if (value.length <= length) return value;

  return value.substring(0, length) + '...';
};

export const currency = (value, currency, decimals) => {
  const digitsRE = /(\d{3})(?=\d)/g;

  value = parseFloat(value);

  if (!isFinite(value) || (!value && value !== 0)) return '';

  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;

  let stringified = Math.abs(value).toFixed(decimals);
  const _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  const i = _int.length % 3;
  const head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  const _float = decimals ? stringified.slice(-1 - decimals) : '';
  const sign = value < 0 ? '-' : '';

  return (
    sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float
  );
};

export const round = (value, decimals) => {
  if (!isFinite(value) || (!value && value !== 0)) return '';

  decimals = decimals != null ? decimals : 0;

  value = Math.round(value) / 1000;

  return Math.abs(value).toFixed(decimals);
};

export const slug = (value) => {
  if (!value || typeof value !== 'string') return '';

  return value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
};

Vue.filter('uppercase', uppercase);
Vue.filter('lowercase', lowercase);
Vue.filter('capitalize', capitalize);
Vue.filter('truncate', truncate);
Vue.filter('currency', currency);
Vue.filter('round', round);
Vue.filter('slug', slug);
